<template>
  <div class="live-home-list">
    <div class="cell-container">
      <ul class="cell-list responsive cell-thum">
        <li v-for="(cell, index) in cellList" :key="cell.thumbnail + '_' + index" @click.prevent="()=>selectCell(cell)">
          <a href="#">
            <div :class="'cell-img picture-area landscape' + ' ' + $route.name">
              <WebpImage :imageInfo="{imageUrl: cell.thumbnail, width: 175, height: 95, alt: getAlt(cell)}"/>
              <ul class="tag-top tag-list" v-top-tag-list="{'badgeList': topTagList(cell), 'badgeType': 'artwork'}" v-if="thumbnailInfo.typeNumber !== 3"></ul>
              <age-tag v-if="cell.age_tag !== ''" :age-code="cell.age_tag" class="tag-age"></age-tag>
              <div class="tag-bottom-time" v-if="cell.time !== '' && cell.time">
              </div>
              <div class="progress-bar" v-if="cell.progress !== ''" v-progress-bar="cell.progress * 100"></div>
            </div>
            <div class="cell-info">
              <div class="cell-title-wrap" v-title-list="{'titleList': cell.title_list}">
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { resizeThumbnail } from '@/common/image.filter'
import { progressBar, topTagList, titleList, bandTitle } from '@/common/directives'
import { getEventListByType } from '@/common/util/event.util'
import { get } from 'lodash'
import { parseUrl } from 'query-string'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import AgeTag from '@/components/tags/AgeTag'
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'CellListLivePlayer',
  components: {
    WebpImage,
    AgeTag
  },
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    },
    containerClassName: {
      type: String
    }
  },
  directives: {
    progressBar,
    topTagList,
    titleList,
    bandTitle
  },
  methods: {
    selectCell (cell) {
      const { onNavigationEvent, onClickEvent } = getEventListByType(cell.event_list)
      if (onClickEvent) {
        EventBus.$emit(ON_CLICK, onClickEvent)
      }
      let navigationUrl = get(onNavigationEvent, 'url', '').replace('.html', '')
      let { url, query } = parseUrl(navigationUrl)
      let section = url.split('/').pop()
      this.$router.push({
        name: PATH_NAME_PLAYER,
        params: {
          section
        },
        query: query
      })
    },
    topTagList (cell) {
      return (get(cell, 'top_taglist', [])).concat(get(cell, 'bottom_taglist', []))
    },
    getAlt (cell) {
      return get(cell, 'title_list.0.text', '')
    }
  }
}
</script>
